'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidCart = function IoAndroidCart(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13 29.5c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.3-3.2 3.3-3.2-1.5-3.2-3.3 1.4-3.2 3.2-3.2z m-9.5-25.5h5.3l1.5 3.3h24.1c0.8 0 1.6 0.7 1.6 1.5 0 0.3-0.1 0.7-0.2 0.8l-5.8 10.1c-0.6 1.1-1.6 1.7-2.8 1.7h-12.1l-1.7 2.5s-0.1 0.4-0.1 0.5c0 0.2 0.1 0.4 0.4 0.4h18.6v3.1h-19c-2.1 0-3.5-1.1-3.5-3.3 0-0.5 0.1-1.2 0.3-1.6l2.5-3.9-5.8-11.8h-3.3v-3.3z m25.5 25.5c1.8 0 3.3 1.4 3.3 3.2s-1.5 3.3-3.3 3.3-3.2-1.5-3.2-3.3 1.4-3.2 3.2-3.2z' })
        )
    );
};

exports.default = IoAndroidCart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-cart.js
// module id = 1860
// module chunks = 0